import 'normalize.css';
import { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { AppStore, wrapper } from '../app/store';
import { isServer } from '../utils/is-server';
import 'react-loading-skeleton/dist/skeleton.css';

const useRequestMetrics = () => {
  useEffect(() => {
    import('@request-metrics/browser-agent')
      .then((RM) => {
        RM.install({ token: process.env.REQUESTMETRICS_TOKEN });
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error('unexpected error', e);
      });
  }, []);
};

if (!isServer() && process.env.NEXT_PUBLIC_MOCK_SERVER) {
  // eslint-disable-next-line global-require
  require('../start-msw-worker');
}

function MyApp({ Component, pageProps }: AppProps) {
  const store = useStore() as AppStore;
  useRequestMetrics();

  if (!store.persistor) {
    return <Component {...pageProps} />;
  }

  return (
    <PersistGate persistor={store.persistor} loading={null}>
      <Component {...pageProps} />
    </PersistGate>
  );
}

export default wrapper.withRedux(appWithTranslation(MyApp));
